// Mirrors FileUploadHelper.PermittedSignatures in WorkNest.Common. The API is the real
// gate; this only filters the picker and names the accepted types, so keep it in step.
export const acceptedAttachmentExtensions = [
    ".csv", ".doc", ".docx", ".eml", ".gif", ".jpeg", ".jpg", ".m4a", ".mov", ".mp3",
    ".mp4", ".msg", ".ogg", ".pdf", ".png", ".ppt", ".pptx", ".txt", ".wav", ".webm",
    ".xls", ".xlsx", ".zip",
];

export const acceptedAttachmentsAttribute = acceptedAttachmentExtensions.join(",");

export const acceptedAttachmentsSummary =
    "You can attach PDF, Word, Excel, PowerPoint, images, audio, video, email, text and ZIP files.";
